import React, { FunctionComponent } from 'react';
import styles from './Icon.module.scss';
import { Icon as SemanticIcon, SemanticICONS } from 'semantic-ui-react';
import { IconSizeProp } from 'semantic-ui-react/dist/commonjs/elements/Icon/Icon';

export interface IconProps {
    icon: SemanticICONS;
    size?: IconSizeProp;
    loading?: boolean;
    disabled?: boolean;
    onClick?(): void;
    color?: 'blue' | 'green' | 'red' | 'black' | 'white' | 'orange';
    ariaLabel?: string;
}

export const Icon: FunctionComponent<IconProps> = ({icon, size, loading, disabled, onClick, color, ariaLabel}) => {
    const clickable = onClick && !disabled ? true : false;
    color = color ? color : clickable ? 'blue' : 'black';

    // If clickable, wrap in a button for accessibility
    if (clickable) {
        return (
            <button
                type="button"
                className={`${styles.iconContainer} ${styles.iconButton}`}
                onClick={onClick}
                disabled={disabled}
                aria-label={ariaLabel || icon}
            >
                <SemanticIcon
                    name={icon}
                    size={size}
                    loading={loading}
                    disabled={disabled}
                    className={`${styles.icon} ${styles[color]}`}
                    aria-hidden="true"
                />
            </button>
        );
    }

    return (
        <span className={styles.iconContainer} aria-hidden={!ariaLabel} aria-label={ariaLabel} role={ariaLabel ? 'img' : undefined}>
            <SemanticIcon
                name={icon}
                size={size}
                loading={loading}
                disabled={disabled}
                className={`${styles.icon} ${styles[color]}`}
            />
        </span>
    )
}